import { Immunisation } from "./model";
import { ImmunisationAction } from "./actions";
import {
    CREATE_IMMUNISATION_SUCCESS,
    LOAD_IMMUNISATIONS_SUCCESS,
    DELETE_IMMUNISATION_SUCCESS,
    SAVE_IMMUNISATION_SUCCESS,
    LOAD_IMMUNISATION_SUCCESS
} from "./actionTypes";

export const reducer = (state: Immunisation[] = [], action: ImmunisationAction) => {
    switch (action.type) {
        case LOAD_IMMUNISATIONS_SUCCESS:
            return action.payload;
        case LOAD_IMMUNISATION_SUCCESS:
            if (!state.find(t => t.id === action.payload.id)) {
                return [ ...state, action.payload ];
            }
            return state.map(t => immunisation(t, action));
        case CREATE_IMMUNISATION_SUCCESS:
            return [...state, action.payload];
        case SAVE_IMMUNISATION_SUCCESS:
            return state.map(c => immunisation(c, action));
        case DELETE_IMMUNISATION_SUCCESS:
            return state.filter(i => i.id !== action.payload);
        default:
            return state;
    }
};

const immunisation = (state: Immunisation, action: ImmunisationAction) => {
    switch (action.type) {
        case LOAD_IMMUNISATION_SUCCESS:
        case SAVE_IMMUNISATION_SUCCESS:
            if (action.payload.id === state.id) {
                return action.payload;
            }
            return state;
        default:
            return state;
    }
};
